import { Component, OnInit } from '@angular/core';
import { RestService } from '../rest.service';
import * as Chart from 'chart.js';
import { Subject } from 'rxjs';
import { UserService } from '../user.service';
import { Spanish } from 'flatpickr/dist/l10n/es';

@Component({
  selector: 'app-parking',
  templateUrl: './parking.component.html',
  styleUrls: ['./parking.component.scss']
})
export class ParkingComponent implements OnInit {

  // CHART 1
  chart1;
  // FlatpickrOptions
  fdesde: any = new Date().toISOString().slice(0, 10);
  fhasta: any = new Date().toISOString().slice(0, 10);
  // OPTIONS
  fdesdeoptions = { onClose: (selectedDates, dateStr, instance) => this.fdesde = dateStr,altFormat: 'Y-m-d' };
  fhastaoptions = { onClose: (selectedDates, dateStr, instance) => this.fhasta = dateStr,altFormat: 'Y-m-d' };

  // CHART 2
  chart2;
  fdesde2: any = new Date().toISOString().slice(0, 10);
  fhasta2: any = new Date().toISOString().slice(0, 10);
  // OPTIONS
  fdesdeoptions2 = { onClose: (selectedDates, dateStr, instance) => this.fdesde2 = dateStr,altFormat: 'Y-m-d' };
  fhastaoptions2 = { onClose: (selectedDates, dateStr, instance) => this.fhasta2 = dateStr,altFormat: 'Y-m-d' };

  // CHART 3
  chart3;
  fdesde3: any = new Date().toISOString().slice(0, 10);
  fhasta3: any = new Date().toISOString().slice(0, 10);

  // OPTIONS
  fdesdeoptions3 = { onClose: (selectedDates, dateStr, instance) => this.fdesde3 = dateStr,altFormat: 'Y-m-d' };
  fhastaoptions3 = { onClose: (selectedDates, dateStr, instance) => this.fhasta3 = dateStr,altFormat: 'Y-m-d' };

    
  // CHART 4
  chart4;
  fdesde4: any = new Date().toISOString().slice(0, 10);
  fhasta4: any = new Date().toISOString().slice(0, 10);

  // OPTIONS
  fdesdeoptions4 = {
    locale: Spanish,
    onClose: (selectedDates, dateStr, instance) => this.fdesde4 = dateStr,altFormat: 'Y-m-d'
  };
  fhastaoptions4 = {
    locale: Spanish,
    onClose: (selectedDates, dateStr, instance) => this.fhasta4 = dateStr,altFormat: 'Y-m-d' 
  };

  // COD INS
  codins = [{ 'id': '989' , 'nombre': 'Bingo Gorrión'},
    { 'id': '461' , 'nombre': 'Bingo Canalejas'}];
  codin;

  showHide = true;
  items: any[] = [];

  optionsdt: DataTables.Settings = {};
  triggerdt: Subject<any> = new Subject();

  finished = false;
  loading = false;

  constructor(public rest: RestService, public user: UserService) {}

  ngOnInit() {
    this.optionsdt = {
      pagingType: 'full_numbers',
      pageLength: 15,
      language: {
        processing: 'Procesando...',
        search: 'Buscar:',
        lengthMenu: 'Mostrar _MENU_',
        info: 'Mostrando desde _START_ al _END_ de _TOTAL_ elementos',
        infoEmpty: 'Mostrando ningún elemento.',
        infoFiltered: '(filtrado _MAX_ elementos total)',
        infoPostFix: '',
        loadingRecords: 'Cargando registros...',
        zeroRecords: 'No se encontraron registros',
        emptyTable: 'No hay datos disponibles en la tabla',
        paginate: {
          first: 'Primero',
          previous: 'Anterior',
          next: 'Siguiente',
          last: 'Último'
        },
        aria: {
          sortAscending: ': Activar para ordenar la tabla en orden ascendente',
          sortDescending: ': Activar para ordenar la tabla en orden descendente'
        }
      },
      responsive: true,
      scrollX: true,
    };

    // Ejecutar API
    this.getAPI();
    //this.chart2 = this.mixedChart('lineChart2', 'Ocupación Bingos', '', []);
    this.getOcupationDay();
    this.getConcurrencia();
    this.getOcupationMonth();
  }

  ngOnDestroy() {
    if (!!this.triggerdt) this.triggerdt.unsubscribe();
  }

  getAPI() {

    this.rest.getDataParking(this.fdesde, this.fhasta, this.codin).subscribe((data) => {

      if (data['data'].length > 0) {
        // Cargando
        this.loading = true;

        this.items = data['data'];
        this.createChart();
        this.triggerdt.next();

        this.loading = false;
        this.finished = true;

        setTimeout(() => {
          this.finished = false;
        }, 500);

      } else {

        this.finished = true;
        setTimeout(() => {
          this.finished = false;
        }, 1500);
      }

    });
  }

  getReAPI() {
    this.loading = true;

    const destroy = new Promise(
      (resolve) => {
        this.triggerdt.unsubscribe();
        resolve();
      }
    );

    this.rest.getDataParking(this.fdesde, this.fhasta, this.codin).subscribe((data) => {

        destroy.then((then) => {
          this.loading = false;

          if (data['data'].length > 0) {
            this.items = data['data'];
            this.createChart();
          }

          this.triggerdt.next();

          this.finished = true;
          setTimeout(() => {
            this.finished = false;
          }, 1500);
        })

      });
  }


  private lineChart(name, label, dataline1, dataline2, nameText) {
    return new Chart(document.getElementById(name), {
      type: 'line',
      data: {
        labels: label,
        datasets: [
          {
            data: dataline1,
            label: nameText,
            borderColor: '#3e95cd',
            fill: false
          },
          {
            data: dataline2,
            label: 'Ocupación máxima',
            borderColor: '#add8e6',
            fill: true
          }
        ]
      },
      options: {
        title: {
          display: true,
          text: nameText
        },
        maintainAspectRatio: false,
        responsive: true
      }
    });
  }

  private mixedChart(nombre, textTitle, labels, dataset_salas) {
    
    return new Chart(document.getElementById(nombre), {
      type: 'line',
      data: {
        labels: labels,
        datasets: dataset_salas
      },
      options: {
        title: {
          display: true,
          text: textTitle
        },
        scales: {
          yAxes: [{
            display: true,
            scaleLabel: {
              display: true
            },
            ticks: {
              beginAtZero: true
              // steps: 10,
              // stepValue: 1500
              // max: 10000
            }
          }]
        },
        events: ['click'],
        legend: { display: true },
        maintainAspectRatio: true,
        responsive: true
      }
    });
  }

  formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
}

  createChart() {
    const datalabel = [];
    const dataline = [];
    const dataline2 = [];

    if (this.chart1) { this.chart1.destroy(); }
    // Chart 1
    for (let jindex = 0; jindex < this.items.length; jindex++) {

      datalabel.push(this.items[jindex]['HoraInicio']);
      dataline.push(this.items[jindex]['ocupacion']);
      dataline2.push(120);

    }
    this.chart1 = this.lineChart('lineChart', datalabel, dataline, dataline2, 'Ocupación Coches en bingos');
  }

  getOcupationDay() {

    if (this.chart2) { this.chart2.destroy(); }

    const promiseDay = new Promise( (resolve) => {

      const arr_dataset = [];

      this.rest.getOcupationDay(this.fdesde2, this.fhasta2, this.codin).subscribe( (data) => {

        for (let index = 0; index < data['data'].length; index++) {
          arr_dataset.push({
            label: data['data'][index]['nombre'],
            data: data['data'][index]['datos'],
            borderColor: this.user.colors[index],
            fill: false,
          });
        }

          resolve(
            { 'label' : data['label'],
            'arr_dataset' : arr_dataset });
      });

    });

    promiseDay
    .then( (ok) => { this.chart2 = this.mixedChart('lineChart2', 'AGRUPADO POR FECHA', ok['label'], ok['arr_dataset']); });
  }

  getOcupationMonth() {

    if (this.chart3) { this.chart3.destroy(); }

    const promiseMonth = new Promise( (resolve) => {

      const arr_dataset = [];

      this.rest.getOcupationMonth(this.fdesde3, this.fhasta3, this.codin).subscribe( (data) => {

        for (let index = 0; index < data['data'].length; index++) {
          arr_dataset.push({
            label: data['data'][index]['nombre'],
            data: data['data'][index]['datos'],
            borderColor: this.user.colors[index],
            fill: false,
          });
        }

          resolve(
            { 'label' : data['label'],
            'arr_dataset' : arr_dataset });
      });

    });

    promiseMonth
    .then( (ok) => { this.chart3 = this.mixedChart('lineChart3', 'AGRUPADO POR MES', ok['label'], ok['arr_dataset']); });

  }

  getConcurrencia() {

    if (this.chart4) { this.chart4.destroy(); }

    const promiseConcurrencia = new Promise( (resolve) => {

      const arr_dataset = [];

      this.rest.getConcurrenciaAbonos(this.fdesde3, this.fhasta3, this.codin).subscribe( (data) => {

        arr_dataset.push({
          label: 'Concurrencia',
          data: data['data'][0]['datos'],
          borderColor: this.user.colors[0],
          fill: false,
        });

          resolve(
            { 'label' : data['label'],
            'arr_dataset' : arr_dataset });
      });

    });

    promiseConcurrencia
    .then( (ok) => {
      this.chart4 = this.mixedChart('lineChart4', 'CONCURRENCIA PARA ABONOS', ok['label'], ok['arr_dataset']);
    });

  }

  getCodIns(){
    this.getOcupationMonth();
    this.getOcupationDay();
    this.getConcurrencia();
    this.getReAPI();
  }











}
